/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import cx from 'classnames';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import PropTypes from 'prop-types';
import React, {Component, lazy, Suspense} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import CorrectMark from 'theme/assets/images/correctmark.svg';
import FalseMark from 'theme/assets/images/falsemark.svg';
import {choiceDiv, textAlignLeft} from './styles.scss';

const Highlight = lazy(() => import('modules/common/Highlight'));

/**
 * Returns a new array whose contents are a copy shuffled of the array.
 * @param {Array} a items to shuffle.
 * http://stackoverflow.com/a/2450976/1673761
 */
const shuffle = (array) => {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;
  const newArray = array.slice();
  // While there remain elements to shuffle...
  while (currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = newArray[currentIndex];
    newArray[currentIndex] = newArray[randomIndex];
    newArray[randomIndex] = temporaryValue;
  }
  return newArray;
};

class QuizChoice extends Component {
  constructor(props) {
    super(props);
    this.state = this.createState(props);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleShortcuts);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.question !== nextProps.question) {
      this.setState(this.createState(nextProps));
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleShortcuts);
  }

  createState = (props) => {
    const {
      choices,
      intl: {formatMessage},
    } = props;
    const quizChoices = choices
      ? choices.map(({node}) => node)
      : [
          {
            answer: formatMessage({id: 'false'}),
            letter: '0',
          },
          {
            answer: formatMessage({id: 'true'}),
            letter: '1',
          },
        ];
    return {
      answer: undefined,
      quizChoices: shuffle(quizChoices),
    };
  };

  choose = (event) => {
    event.preventDefault();
    if (
      this.state.answer === undefined &&
      event.currentTarget.name !== undefined
    ) {
      this.setState({answer: event.currentTarget.name});
      this.props.checkAnswer(event.currentTarget.name);
    }
  };

  handleShortcuts = (event) => {
    if (typeof this.state.answer === 'undefined') {
      const {key} = event;
      const answerIndex = parseInt(key, 10);
      const {quizChoices} = this.state;
      if (key && quizChoices.length >= answerIndex) {
        const answerId = quizChoices[answerIndex - 1].letter;
        this.setState({
          answer: answerId,
        });
        this.props.checkAnswer(answerId);
      }
    }
  };

  render() {
    const {
      question,
      result,
      validAnswer,
      isNanoDegree,
      intl: {formatMessage},
    } = this.props;
    return (
      <>
        <Suspense fallback={<LoadingIndicator />}>
          <Highlight triggerUpdate={question} />
        </Suspense>
        <p
          className={`pa3 f6 f4-ns fw6 tr ${textAlignLeft}`}
          dangerouslySetInnerHTML={{
            __html: question,
          }}
        />
        <div className="pa3 silver tr">
          <p className="gray" data-cy="quiz-choice-title">
            <FormattedMessage
              id="choose_correct_answer"
              defaultMessage="Choose the correct answer below"
            />
          </p>
        </div>
        {this.state.quizChoices &&
          this.state.quizChoices.map(({answer: choice, letter: key}) => {
            // {A: 'Blahblah', B: null, a0: null}
            return (
              <div key={key} className="tc">
                <a
                  name={key}
                  className={cx(
                    'db pv3 bg-near-white mb3 b br2 ph1 flex items-center justify-between',
                    {
                      pointer: this.state.answer === undefined,
                      'ba br--green green':
                        validAnswer === key &&
                        result !== undefined &&
                        !isNanoDegree,
                      'ba br--red red':
                        this.state.answer === key &&
                        this.state.answer !== validAnswer,
                      // Add a fake class 'nano-degree' to identify this condition
                      'ba br--green green nano-degree':
                        validAnswer === key && result && isNanoDegree,
                    },
                  )}
                  onClick={this.choose}
                  data-cy="answer"
                >
                  <div className="flex w-100">
                    <div className="tr flex2" />
                    <p
                      className={`${choiceDiv} ${textAlignLeft}`}
                      dangerouslySetInnerHTML={{
                        __html: choice,
                      }}
                    />
                    <div className="tl flex2 ph2">
                      {this.state.answer === key &&
                        result !== undefined &&
                        (result ? (
                          <img src={CorrectMark} alt="correct mark" />
                        ) : (
                          <img src={FalseMark} alt="false mark" />
                        ))}
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        <div className="pb2">
          {this.props.result !== undefined &&
            (this.props.result ? (
              <span className="green absolute">
                {formatMessage({id: 'correct'})}!
              </span>
            ) : (
              <span className="red absolute">
                {formatMessage({id: 'wrong'})}!
              </span>
            ))}
        </div>
      </>
    );
  }
}

QuizChoice.propTypes = {
  checkAnswer: PropTypes.func.isRequired,
  result: PropTypes.bool,
  question: PropTypes.string.isRequired,
  quiz_choices: PropTypes.array, // eslint-disable-line
  type: PropTypes.string.isRequired, // eslint-disable-line
  validAnswer: PropTypes.string.isRequired,
  isNanoDegree: PropTypes.bool.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(QuizChoice);
